// Brand constants
export const BRAND = {
  name: 'Wrongfully Arrested SA',
  tagline: 'Arrested by the police? You could have a valid compensation claim.',
  city: 'Serving clients across South Africa',
  phone: '+27 64 636 9929',
  email: 'help@myarrestclaim.com',
  whatsappNumber: '27646369929',
  whatsappDefaultMessage: "Hi, I'd like to see if I have a valid unlawful arrest claim.",
  facebook: 'https://www.facebook.com/profile.php?id=61592121777526',
  domain: 'myarrestclaim.com',
};

export const whatsappLink = (message) => {
  const msg = message || BRAND.whatsappDefaultMessage;
  return `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;
};

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/know-your-rights', label: 'Your Rights' },
  { to: '/case-studies', label: 'Case Examples' },
  { to: '/faq', label: 'FAQ' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];
